<template>
    <ModalComponent
        title="Quieres liberar el asiento"
        name="liberarAsiento"
        v-on:close="() => close()"
    >
        <div class="row">
            <div class="col-12 text-center">
                <h1 class="font-weight-bold">LIBERAR</h1>
            </div>
            <div class="col-12 text-center">
                <Button type="button" name="button" @click="liberarAsiento()">SI</Button>
            </div>
        </div>

    </ModalComponent>
</template>


<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    export default {
        props: ['abonado_id','evento' , 'sesion'],
        data() {
            return {
                loading: false,
                error: null,  
            }
        },
        methods: {
            liberarAsiento() {
                this.loading = true;

                const params = {
                    filters : {},
                    evento_id: this.evento.id,
                    sesion_id: this.sesion.id,
                    abonado_id: this.abonado_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.liberar.asientos'), params).then(res => {
                    var mensaje = res.data.message.message;
                    this.$toast.success(mensaje);
                }).catch(error => {
                    var mensaje = error.response.data.message.error;
                    this.$toast.error(mensaje);
                }).finally(() => this.$emit('close'));
            },
            close() {
                this.$emit('close');
            },
        },
        components: {
            ModalComponent
        }
    }
</script>